export const listDocumentsSafeCarsService = (fetch) => async () => {
  try {
    const response = await fetch({
      url: "/api/v2/list/documents/vehiculos/seguros",
    });
    console.log("Response from listDocumentsSafeCarsService:", response);
    return response;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message);
  }
};
